module.exports = __webpack_public_path__ + "static/media/team.566344b4.jpeg";